import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  
  const phoneNumber = '237653989061'; // +237 653 989 061
  const message = encodeURIComponent('Bonjour, je souhaite en savoir plus sur vos services.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-3 bg-[#25D366] text-white px-5 py-3 shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300 group"
      data-testid="whatsapp-button"
      aria-label={t('contact.whatsapp')}
    >
      <MessageCircle className="w-5 h-5" />
      <span className="font-body text-sm font-medium hidden md:inline">WhatsApp</span>
    </a>
  );
};
